import { FC } from "react";
import { useTranslation } from "react-i18next";
import { MdChevronRight, MdOutlineDescription } from "react-icons/md";
import { RichTextLoading } from "src/components";
import GiftcardHtml from "src/Modules/GiftCards/pages/GiftcardDetails/components/GiftcardHtml/GiftcardHtml";
import Carrier from "@Components/Carrier/Carrier";

const TermsBarMob: FC<{ terms: string; loading?: boolean }> = ({ terms, loading }) => {
  const { t } = useTranslation();
  if (!loading && !terms) return null;

  return (
    <Carrier
      label={<span className="font-semibold">{t("PointsExchange.exchange.termsAndConditions")}</span>}
      renderTrigger={({ open }) => (
        <button
          type="button"
          onClick={open}
          className="bg-background-default outline-border-subtle flex w-full items-center gap-3 rounded-xl p-4 text-start outline transition-colors"
        >
          <div className="bg-background-primary-lighter text-icon-active flex h-10 w-10 shrink-0 items-center justify-center rounded-full">
            <MdOutlineDescription className="h-5 w-5" />
          </div>
          <span className="text-font-default flex-1 text-sm font-semibold">{t("PointsExchange.exchange.termsAndConditions")}</span>
          <MdChevronRight className="text-icon-minimal h-5 w-5 shrink-0 rtl:-scale-x-100" />
        </button>
      )}
      renderSheet={() => (loading ? <RichTextLoading /> : <GiftcardHtml className="text-font-default flex flex-col gap-2 p-4 text-xs" html={terms} />)}
    />
  );
};

export default TermsBarMob;
